import React from 'react';
import { Plus } from 'lucide-react';
import { buttonVariants } from './ui/button';
import { cn } from '../lib/utils';
import { NEW_COLLABORATION_URL } from '../config';

export default function Header() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h1 className="text-2xl font-semibold">Influencers</h1>
        <p className="text-muted-foreground text-sm">Panel de colaboraciones</p>
      </div>
      <a
        href={NEW_COLLABORATION_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(buttonVariants({ variant: 'default' }), 'no-underline')}
      >
        <Plus className="h-4 w-4" />
        Nueva colaboración
      </a>
    </div>
  );
}
